import { Controller } from "@hotwired/stimulus"
import { post } from "../forum/api_client"
import { loadTranslations, t } from "../forum/i18n"
import { escapeHtml } from "../forum/renderer"

export default class extends Controller {
  static values = { categoryId: String }

  connect() {
    loadTranslations()
    this.form = this.element.querySelector('form')
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.submit(e))
    }
  }

  async submit(event) {
    event.preventDefault()

    const titleInput = this.form.querySelector('[name="title"]')
    const contentInput = document.getElementById('forum_topic_raw_content') || this.form.querySelector('[name="raw_content"]')
    const formatSelect = document.getElementById('forum_topic_content_format') || this.form.querySelector('[name="content_format"]')
    const submitBtn = this.form.querySelector('button[type="submit"]')

    const title = titleInput?.value?.trim()
    const content = contentInput?.value?.trim()
    const contentFormat = formatSelect?.value || 'html'

    if (!title || !content) return

    submitBtn.disabled = true
    this.clearErrors()

    try {
      const response = await post('/topics', {
        category_id: this.categoryIdValue,
        topic: { title, content, content_format: contentFormat }
      })

      const topicId = response.data?.id
      if (topicId) {
        window.location.href = `/forum/topics/${topicId}`
      }
    } catch (e) {
      const errors = e.body?.errors || [e.message]
      this.showErrors(errors)
    } finally {
      submitBtn.disabled = false
    }
  }

  showErrors(errors) {
    const errorsHtml = Array.isArray(errors)
      ? errors.map(err => `<li>${escapeHtml(err)}</li>`).join('')
      : `<li>${escapeHtml(errors)}</li>`
    const alertHtml = `<div class="alert alert-danger" id="topic-form-errors"><ul class="mb-0">${errorsHtml}</ul></div>`
    this.form.insertAdjacentHTML('afterbegin', alertHtml)
  }

  clearErrors() {
    const existing = document.getElementById('topic-form-errors')
    if (existing) existing.remove()
  }
}
